import { InjectionToken } from '@angular/core';

/**
 * Api base url
 */
export const API_BASE_URL = new InjectionToken('Api Base Url');

/**
 * Api base url for user settings
 */
export const US_BASE_URL = new InjectionToken('User settings Base Url');
